import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { IBreezeEntity } from "@common/lib/data/breeze-entity.interface";
import { ErrorHandlingUtilities } from "@common/lib/utilities/error-handling-utilities";
import { lastValueFrom } from "rxjs";
import { ADAPT_DIALOG_DATA } from "../adapt-common-dialog.globals";
import { BaseDialogWithDiscardConfirmationComponent } from "../base-dialog-with-discard-confirmation.component/base-dialog-with-discard-confirmation.component";

export interface IHandleFailedSaveDialogData {
    entities: IBreezeEntity[];
    error?: any;
}

@Component({
    templateUrl: "./handle-failed-save-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class HandleFailedSaveDialogComponent extends BaseDialogWithDiscardConfirmationComponent<IHandleFailedSaveDialogData> {
    public readonly dialogName = "HandleFailedSave";
    public entitiesToConfirm = this.data.entities;

    public latestFailure?: string;

    public constructor(
        @Inject(ADAPT_DIALOG_DATA) private data: IHandleFailedSaveDialogData,
    ) {
        super();

        if (data.error) {
            this.latestFailure = ErrorHandlingUtilities.getHttpResponseMessage(data.error);
        }
    }

    @Autobind
    public async saveAndClose() {
        try {
            this.latestFailure = undefined;
            await lastValueFrom(this.commonDataService.saveEntities(this.data.entities));
            this.resolve(this.data);
        } catch (e) {
            this.latestFailure = ErrorHandlingUtilities.getHttpResponseMessage(e);
        }
    }
}
